import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from "baseui/modal";
import { TScheduler } from "../types";
import ExceptionsView from "./ExceptionsView";
import { FormattedMessage } from "react-intl";
import { useStyletron } from "baseui";
import { LoadingView } from "../../../../components";
import useExceptionSchedule from "../hooks/useExceptionSchedule";
import useIsMobile from "../../../../hooks/useIsMobile/useIsMobile";

const ExceptionsDialog: React.FC<{
  isOpen: boolean,
  app: TScheduler
  setIsOpen: (value: boolean) => void,
}> = ({ isOpen, setIsOpen, app }) => {
  const [css, theme] = useStyletron();
  const mobile = useIsMobile();
  const { exceptionSchedule, hasChanges, isLoading, isSuccess, error, save, isSaving, add, update, remove } = useExceptionSchedule(app.id, app.resourceGroupId);
  const handleApplyChanges = () => save();

  return (
    <Modal size={'full'} closeable onClose={() => setIsOpen(false)} isOpen={isOpen} overrides={{
      Dialog: {
        style: {
          width: "90vw",
          height: "90vh",
          display: "flex",
          flexDirection: "column",
        },
      },
    }}>
      <ModalHeader><FormattedMessage id="Scheduler.ExceptioSchedules" defaultMessage="Exceptions" /></ModalHeader>
      <ModalBody style={{ flex: "1 1 0", overflow: mobile ? 'auto' : undefined }}>
        <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
          <ExceptionsView items={exceptionSchedule} hasChanges={hasChanges} onAdd={add} onDelete={remove} onUpdate={update} {...app}></ExceptionsView>
        </LoadingView>
      </ModalBody>
      <ModalFooter>
        <ModalButton kind="tertiary" onClick={() => { setIsOpen(false); }}>
          <FormattedMessage id="cancel" defaultMessage="Cancel" />
        </ModalButton>
        <ModalButton isLoading={isSaving} disabled={!hasChanges} onClick={handleApplyChanges}><FormattedMessage id="applyChanges" defaultMessage="Ok" /></ModalButton>
      </ModalFooter>
    </Modal>
  )

}
export default ExceptionsDialog